import type { OrderResourceSelectBoxOptions } from "@mittwald/flow-components/dist/components/OrderResourceSelect/components";
import OrderResourceSelect from "@mittwald/flow-components/dist/components/OrderResourceSelect/OrderResourceSelect";
import React from "react";
import { additionalDataComparePrice } from "../../../../../utils/articles";
import { RelocationSelectBoxOption } from "../../../../RelocationSelectBoxOption";
import { StepHeaderItem } from "../../../../StepHeaderItem";

export const CompareSection: React.FC = () => {
  const options: OrderResourceSelectBoxOptions = [
    {
      title: "default.headline",
      value: "default",
      description: "default.description",
      additionalInfo: {
        i18n: "inclusive",
      },
    },
    {
      title: "additionalCompare.headline",
      value: "additionalCompare",
      description: "additionalCompare.description",
      additionalInfo: {
        i18n: {
          text: `+ ${additionalDataComparePrice},00 €`,
        },
      },
    },
  ];

  return (
    <>
      <StepHeaderItem headline="compare.headline"></StepHeaderItem>

      <OrderResourceSelect
        _mt="m"
        name="additionalServices.dataCompare"
        optionComponent={RelocationSelectBoxOption}
        optionContainerAlignment="stretch"
        options={options}
        rules={{
          required: true,
        }}
      />
    </>
  );
};
